import { useEffect, useState } from 'react';
import { TaskStatus } from '../../models/taskService.model';
import { taskService } from '../../services/community/taskService';

export default function useTaskStatuses(communityId: number | undefined): {
  statuses: TaskStatus[];
  loading: boolean;
  reload: () => void;
  createStatus: (name: string, color?: string) => Promise<TaskStatus>;
  deleteStatus: (statusId: number) => Promise<void>;
  updateStatus: (statusId: number, data: { name?: string; color?: string; order?: number }) => Promise<void>;
} {
  const [statuses, setStatuses] = useState<TaskStatus[]>([]);
  const [loading, setLoading] = useState(false);

  const load = () => {
    if (!communityId) return;
    setLoading(true);
    taskService
      .getStatuses(communityId)
      .then(setStatuses)
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    load();
  }, [communityId]);

  const createStatus = async (name: string, color?: string) => {
    const created = await taskService.createStatus(communityId!, name, color);
    setStatuses((prev) => [...prev, created]);
    return created;
  };

  const deleteStatus = async (statusId: number) => {
    await taskService.deleteStatus(communityId!, statusId);
    setStatuses((prev) => prev.filter((s) => s.statusId !== statusId));
  };

  const updateStatus = async (statusId: number, data: { name?: string; color?: string; order?: number }) => {
    const updated = await taskService.updateStatus(communityId!, statusId, data);
    setStatuses((prev) => prev.map((s) => (s.statusId === statusId ? updated : s)));
  };

  return { statuses, loading, reload: load, createStatus, deleteStatus, updateStatus };
}
